import type { EntityTemplate } from '../types/entities';

export const characterTemplateKeys = ['charakter', 'charackter'];
export const groupTemplateKeys = ['group'];

/** Collections belonging to a base template also accept its specializations. */
export function templateInheritsFrom(templateId: string, baseTemplateId: string, templates: EntityTemplate[]) {
  const byId = new Map(templates.map((template) => [template.id, template]));
  const visited = new Set<string>();
  let currentId: string | null | undefined = templateId;
  while (currentId && !visited.has(currentId)) {
    if (currentId === baseTemplateId) return true;
    visited.add(currentId);
    currentId = byId.get(currentId)?.parentTemplateId;
  }
  return false;
}

/** A template restriction always includes every specialization of that template. */
export function templateMatchesAllowedKeys(templateKey: string, allowedKeys: string[], templates: EntityTemplate[]) {
  if (!allowedKeys.length) return true;
  const allowed = new Set(allowedKeys);
  const byId = new Map(templates.map((template) => [template.id, template]));
  let current = templates.find((template) => template.key === templateKey);
  const visited = new Set<string>();
  while (current && !visited.has(current.id)) {
    if (allowed.has(current.key)) return true;
    visited.add(current.id);
    current = current.parentTemplateId ? byId.get(current.parentTemplateId) : undefined;
  }
  return allowed.has(templateKey);
}

/** Whether a template is the character base template or any of its specializations. */
export function isCharacterTemplate(templateKey: string, templates: EntityTemplate[]) {
  return templateMatchesAllowedKeys(templateKey, characterTemplateKeys, templates);
}

/** Whether a template is the group base template or one of its specializations. */
export function isGroupTemplate(templateKey: string, templates: EntityTemplate[]) {
  const groupKeys = [...groupTemplateKeys, ...templates.filter((template) => template.isGroup).map((template) => template.key)];
  return templateMatchesAllowedKeys(templateKey, groupKeys, templates);
}
